import { motion } from "framer-motion";
import { Lock, Sparkles, Heart, DollarSign, Calendar, Brain } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const LOCKED = [
  { icon: Heart, title: "Love & Compatibility (Deep)", tease: "Aapke rishte ka sabse bada test abhi aane wala hai..." },
  { icon: DollarSign, title: "Money Secret & Blockage", tease: "Aapka paisa ek specific jagah se leak ho raha hai..." },
  { icon: Calendar, title: "5-Year Future Timeline", tease: "Agle saal ek turning point aapka wait kar raha hai..." },
  { icon: Brain, title: "Deep Numerology Breakdown", tease: "Aapka destiny number kuch alag hi keh raha hai..." },
];

export const PremiumNudge = ({ open, name, onReveal }) => (
  <Dialog open={open} onOpenChange={() => {}}>
    <DialogContent className="bg-white border-0 max-w-sm mx-auto rounded-3xl shadow-2xl p-0 overflow-hidden [&>button]:hidden" data-testid="premium-nudge-dialog">
      <div className="px-6 pt-7 pb-4 bg-gradient-to-b from-amber-50 to-white">
        <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-amber-700 bg-amber-100 px-3 py-1 rounded-full">
          <Lock className="w-3 h-3" /> Premium Locked
        </span>
        <DialogTitle className="mt-3 text-lg font-bold text-gray-900 leading-snug" style={{ fontFamily: 'Space Grotesk' }} data-testid="premium-nudge-title">
          {name ? `${name.split(" ")[0]}, ` : ""}abhi sabse important baat baaki hai...
        </DialogTitle>
        <DialogDescription className="text-sm text-gray-600 mt-1.5 leading-relaxed" data-testid="premium-nudge-teaser">
          Aapke chart mein kuch aisa dikh raha hai jo maine abhi tak bataya nahi. Yeh sab aapki Premium report mein ready hai.
        </DialogDescription>
      </div>
      <div className="px-6 space-y-2.5">
        {LOCKED.map(({ icon: Icon, title, tease }, i) => (
          <motion.div key={title} initial={{ opacity: 0, x: -12 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.15 + i * 0.1 }}
            className="relative rounded-2xl border border-gray-100 bg-gray-50/70 p-3 overflow-hidden" data-testid={`premium-nudge-section-${i}`}>
            <div className="flex items-center gap-2 mb-1">
              <Icon className="w-4 h-4 text-amber-600" />
              <span className="text-xs font-bold text-gray-800">{title}</span>
              <Lock className="w-3 h-3 text-gray-400 ml-auto" />
            </div>
            <p className="text-xs text-gray-600 blur-[3px] select-none">{tease} {tease}</p>
          </motion.div>
        ))}
      </div>
      <div className="px-6 pb-6 pt-5">
        <Button data-testid="premium-nudge-reveal-btn" onClick={onReveal} className="btn-primary w-full py-4 text-base rounded-2xl">
          <span className="flex items-center gap-2"><Sparkles className="w-4 h-4" /> Reveal Now</span>
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
